import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-saverly-primary/10 to-saverly-deep/10 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-saverly-dark font-poppins mb-6">
            Simple, Transparent
            <span className="block text-saverly-primary">Pricing</span>
          </h1>
          <p className="text-xl text-saverly-gray font-inter max-w-3xl mx-auto">
            Choose the plan that works best for your family. Start free, upgrade when you're ready.
          </p>
        </div>
      </section>

      {/* Pricing Cards */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-8">
            
            {/* Free Plan */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 relative">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 font-poppins mb-4">Starter</h3>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-900">$0</span>
                  <span className="text-gray-600 ml-2">/month</span>
                </div>
                <p className="text-saverly-gray mb-8">Perfect for trying out Saverly</p>
                
                <ul className="space-y-4 mb-8 text-left">
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">5 AI meal plans per week</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Browse live sales from Kroger family stores</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Smart shopping lists</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Product matching for ingredients</span>
                  </li>
                </ul>
                
                <Link to="/signup">
                  <Button className="w-full bg-gray-900 hover:bg-gray-800 text-white py-3 rounded-xl font-semibold transition-all duration-200">
                    Start Free
                  </Button>
                </Link>
              </div>
            </div>

            {/* Pro Plan - Featured */}
            <div className="bg-white rounded-2xl shadow-xl border-2 border-saverly-primary p-8 relative transform scale-105">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-saverly-primary text-white px-6 py-2 rounded-full text-sm font-semibold">
                  Most Popular
                </span>
              </div>
              
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 font-poppins mb-4">Pro</h3>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-900">$4.99</span>
                  <span className="text-gray-600 ml-2">/month</span>
                </div>
                <p className="text-saverly-gray mb-8">Best for families who meal plan regularly</p>
                
                <ul className="space-y-4 mb-8 text-left">
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Unlimited AI meal plans</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">18 dietary preferences (Vegan, Keto, etc.)</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Complete meals (10-20 ingredients each)</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Automatic product matching</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Detailed nutrition information*</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-saverly-primary mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-saverly-gray">Priority support</span>
                  </li>
                </ul>
                
                <p className="text-xs text-gray-500 mb-6 text-left">*When available from retailer</p>
                
                <Link to="/signup">
                  <Button className="w-full bg-saverly-primary hover:bg-saverly-primary-dark text-white py-3 rounded-xl font-semibold transition-all duration-200">
                    Start Free Trial
                  </Button>
                </Link>
                <p className="text-sm text-gray-500 mt-2">14-day free trial, then $4.99/month</p>
              </div>
            </div>

            {/* Family Plan */}
            <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 relative opacity-75">
              <div className="absolute top-4 right-4">
                <span className="bg-saverly-accent text-white px-4 py-1 rounded-full text-xs font-semibold">
                  Coming Soon
                </span>
              </div>
              
              <div className="text-center">
                <h3 className="text-2xl font-bold text-gray-900 font-poppins mb-4">Family</h3>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-400">Coming Soon</span>
                </div>
                <p className="text-saverly-gray mb-8">Perfect for large families or meal prep enthusiasts</p>
                
                <ul className="space-y-4 mb-8 text-left">
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-gray-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-400">Everything in Pro</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-gray-400 mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-400">Shared family account (up to 6 members)</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-gray-400 mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-400">Collaborative meal planning</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-gray-400 mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-400">Bulk meal prep features</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-gray-400 mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-400">Priority customer support</span>
                  </li>
                  <li className="flex items-center">
                    <svg className="w-5 h-5 text-gray-400 mr-3" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-400">Advanced analytics & insights</span>
                  </li>
                </ul>
                
                <Button disabled className="w-full bg-gray-300 text-gray-500 py-3 rounded-xl font-semibold cursor-not-allowed">
                  Coming Soon
                </Button>
                <p className="text-sm text-gray-400 mt-2">We're working on it!</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-saverly-dark font-poppins mb-4">
              Frequently Asked Questions
            </h2>
            <p className="text-xl text-saverly-gray font-inter">
              Everything you need to know about our pricing.
            </p>
          </div>

          <div className="space-y-8">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                How does the free trial work?
              </h3>
              <p className="text-saverly-gray font-inter">
                All paid plans come with a 14-day free trial. No credit card required to start. You can cancel anytime during the trial with no charges.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                Can I change my plan later?
              </h3>
              <p className="text-saverly-gray font-inter">
                Absolutely! You can upgrade or downgrade your plan at any time. Changes take effect immediately, and we'll prorate any differences.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                What stores does Saverly support?
              </h3>
              <p className="text-saverly-gray font-inter">
                Currently, Saverly is integrated with Kroger family stores (Kroger, Fry's, Ralph's, King Soopers, Smith's, and more). We're working on adding more retailers in the future.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                How does the AI meal planner work?
              </h3>
              <p className="text-saverly-gray font-inter">
                Our AI (powered by OpenAI) generates complete meal plans based on products you select and your dietary preferences. Each meal includes a main dish, sides, vegetables, and all necessary ingredients (typically 10-20 items), which are automatically matched to products available at your local Kroger family store.
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 font-poppins mb-3">
                Are the prices shown accurate?
              </h3>
              <p className="text-saverly-gray font-inter">
                We display real-time prices from Kroger's API, but prices may vary by location and can change. Always verify prices at checkout.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-saverly-primary to-saverly-accent text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold font-poppins mb-6">
            Ready to Start Saving?
          </h2>
          <p className="text-xl text-white font-inter mb-8">
            Join thousands of families saving time and money with AI-powered meal planning.
          </p>
          <Link to="/signup">
            <Button size="lg" className="bg-white text-saverly-primary hover:bg-gray-100 px-8 py-4 text-lg font-semibold rounded-xl shadow-lg transition-all duration-200 transform hover:scale-105">
              Start Your Free Trial
            </Button>
          </Link>
          <p className="text-sm text-white mt-4">No credit card required • 14-day free trial</p>
        </div>
      </section>
    </div>
  );
};

export default PricingPage; 